import { Typography, ImageList, ImageListItem, Paper, Grid, Container } from '@mui/material';

const ispImages = [
  { "src": "/images/n8.jpg", "title": "n8" },
  { "src": "/images/n9.jpg", "title": "n9" },
  { "src": "/images/n10.jpg", "title": "n10" },
  { "src": "/images/n1.jpg", "title": "n1" },
  { "src": "/images/n2.jpg", "title": "n2" },
  { "src": "/images/n3.jpg", "title": "n3" },
  { "src": "/images/n4.jpg", "title": "n4" },
  { "src": "/images/n5.jpg", "title": "n5" },
  { "src": "/images/n6.jpg", "title": "n6" }
];

const ospImages = [
  { "src": "/images/e1.jpg", "title": "e1" },
  { "src": "/images/e2.jpg", "title": "e2" },
  { "src": "/images/e3.jpg", "title": "e3" },
  { "src": "/images/e4.jpg", "title": "e4" }
];

const ccrImages = [
  { "src": "/images/c1.jpg", "title": "c1" },
  { "src": "/images/c2.jpg", "title": "c2" },
];

function OurService() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Our Services
          </Typography>
          <Typography variant="body1" gutterBottom>
            NEPTUNE TECHNOLOGY PTE. LTD. specializes in the design, installation, repair and certification of voice and data hardwire cable networks for the following applications:
          </Typography>
          <ul>
            <li>
              <Typography variant="body1" gutterBottom>
                Professional Office / Warehouse
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Mall / Retail Outlet
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Condominium Structures
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Residential Communities
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Government Facilities
              </Typography>
            </li>
          </ul>
          <Typography variant="body1" gutterBottom>
            Types of Cable:
          </Typography>
          <ul>
            <li>
              <Typography variant="body1" gutterBottom>
                Cat 5E Cable
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Cat 6 Cable
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Fibre Optic
              </Typography>
            </li>
          </ul>
          <Typography variant="body1" gutterBottom>
            Our aim is to provide the most cost-effective, long-term solutions for our clients’ needs, whether the project involves the design and installation of networks requiring fibre rings.
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            Services
          </Typography>
          <Typography variant="h6" gutterBottom>
            Inside Plant (ISP) – Cabling Solutions
          </Typography>
          <Typography variant="body1" gutterBottom>
            We provide these essential fibre optic cabling services for inside the premises or building:
          </Typography>
          <ul>
            <li>
              <Typography variant="body1" gutterBottom>
                Fibre optic cable laying, design and installation
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Fibre optic splicing, termination and testing
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Supply and Installation of Switches
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Supply and Installation of Racks / Wall Mount Enclosures
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                Supply and Installation of Patch Panels
              </Typography>
            </li>
            <li>
              <Typography variant="body1" gutterBottom>
                provision and installation of ABF fiber
              </Typography>
            </li>
          </ul>
          <Container>
            <ImageList sx={{ width: 600, height: 800 }} cols={3} rowHeight={250}>
              {ispImages.map((item) => (
                <ImageListItem key={item.title}>
                  <img src={`${item.src}`} alt={item.title} />
                </ImageListItem>
              ))}
            </ImageList>
          </Container>

          <Typography variant="h6" gutterBottom>
            Outside Plant (OSP) Cabling Solutions
          </Typography>
          <Typography variant="body1" gutterBottom>
            We support your fibre optic network construction and design by providing skilled manpower and equipment for these outside plant services:
          </Typography>
          <ul>
            <li>
              <Typography variant="body1" gutterBottom>
                Underground Fibre optic cable laying, design and installation
              </Typography>
            </li>
          </ul>
          <Container>
            <ImageList sx={{ width: 600, height: 500 }} cols={2} rowHeight={200}>
              {ospImages.map((item) => (
                <ImageListItem key={item.title}>
                  <img src={`${item.src}`} alt={item.title} />
                </ImageListItem>
              ))}
            </ImageList>
          </Container>

          <Typography variant="h6" gutterBottom>
            Concrete Crack / Water Leaking Repair
          </Typography>
          <Typography variant="body1" gutterBottom>
            We provide various types of concrete crack repair services:
          </Typography>
          <ul>
            <li>
              Joint Injection
            </li>
            <li>
              Crack Injection
            </li>
            <li>
              PU Grouting &amp; PU Injection
            </li>
            <li>
              Epoxy Injection
            </li>
            <li>
              Epoxy Grouting
            </li>
          </ul>

          <Container>
            <ImageList sx={{ width: 600, height: 500 }} cols={2} rowHeight={500}>
              {ccrImages.map((item) => (
                <ImageListItem key={item.title}>
                  <img src={`${item.src}`} alt={item.title}/>
                </ImageListItem>
              ))}
            </ImageList>
          </Container>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default OurService;